module.exports = __webpack_public_path__ + "static/img/vivodcb1.462a23f4.png";